import { render, staticRenderFns } from "./modalities.vue?vue&type=template&id=3560f070&scoped=true"
import script from "./modalities.vue?vue&type=script&lang=js"
export * from "./modalities.vue?vue&type=script&lang=js"
import style0 from "./modalities.vue?vue&type=style&index=0&id=3560f070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560f070",
  null
  
)

export default component.exports